import { $api } from "@/services/api";
import store from "@/store";

const state = {
  totalChangeDelivery: {
    all: 0,
    inProcess: 0,
  },
};

const getters = {
  totalChangeDelivery: (state) => state.totalChangeDelivery,
};

const mutations = {
  async setAllChangeDelivery(state, total) {
    state.totalChangeDelivery.all = total;
  },
  async setInProcessChangeDelivery(state, total) {
    state.totalChangeDelivery.inProcess = total;
  },
};

const actions = {
  async getTotalChangeDelivery({ commit }) {
    const poReceiptDateResponse =
      await $api.v_po_receipt_dates.getByQueryString(
        store.getters.isSpecialUser
          ? `?status=Waiting for Approval&po_id[$gt]=0&is_active=true`
          : `?status=Waiting for Approval&po_id[$gt]=0&is_active=true&buyer_employee_code=${store.getters.user.empCodeHC}`
      );
    if (poReceiptDateResponse) {
      commit("setAllChangeDelivery", poReceiptDateResponse.total);
    } else {
      commit("setAllChangeDelivery", 0);
    }
  },
};

export default { state, getters, mutations, actions };
